export const SUPPORT_EMAIL = "hello@livemonetize.com"; // TODO: change to support email
export const NOTIFICATIONS_EMAIL = "no-reply@notifications.livemonetize.com";

export const STRIPE_FONT_SRC = [
  {
    cssSrc:
      "https://fonts.googleapis.com/css2?family=Mona+Sans:ital,wght@0,200..900;1,200..900&display=swap",
  },
];
